import React from 'react'
import { LoadingOutlined, LikeOutlined, DislikeOutlined, LikeFilled, DislikeFilled } from '@ant-design/icons'
import { MarkdownRenderer } from './MarkdownRenderer'
import type { Message, SkillKey } from '../types'


interface MessageListProps {
  messages: Message[]
  activeSkill: SkillKey
  onLike: (msgId: string) => void
  onDislike: (msgId: string) => void
}

export const MessageList: React.FC<MessageListProps> = ({
  messages,
  activeSkill,
  onLike,
  onDislike
}) => {
  return (
    <div className="message-list">
      {messages.map(msg => (
        <div
          key={msg.id}
          className={`message-item ${msg.role}`}
        >
          {msg.role === 'assistant' && <div className="msg-avatar"></div>}
          <div className="msg-bubble-wrapper">
            <div className="msg-content">
              {msg.loading && !msg.content ? (
                <div className="msg-loading">
                  <LoadingOutlined spin />
                  <span>正在思考中...</span>
                </div>
              ) : msg.role === 'assistant' && msg.content ? (
                // 使用 React Markdown 渲染，保持链接 DOM 稳定，可以点击
                <MarkdownRenderer
                  content={msg.content}
                  skill={activeSkill}
                  isStreaming={msg.loading}
                />
              ) : (
                msg.content
              )}
            </div>
            {/* AI 消息底部操作栏 - 有实际内容时才显示 */}
            {msg.role === 'assistant' && !msg.loading && !msg.stopped && msg.content && msg.content.trim() && (
              <div className="msg-actions">
                <button
                  className={`action-btn ${msg.liked ? 'liked' : ''}`}
                  onClick={() => onLike(msg.id)}
                >
                  {msg.liked ? <LikeFilled /> : <LikeOutlined />}
                  <span>有帮助</span>
                </button>
                <button
                  className={`action-btn ${msg.disliked ? 'disliked' : ''}`}
                  onClick={() => onDislike(msg.id)}
                >
                  {msg.disliked ? <DislikeFilled /> : <DislikeOutlined />}
                  <span>需改进</span>
                </button>
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  )
}